export default __webpack_public_path__ + "static/media/chevrolet-car-icon.ca1c3314.png";